import Box from "@mui/material/Box";
import SvgToIcon from "../../../../icons/SvgToIcon";

const IconAboveNode = ({ icon }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "-10px",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <SvgToIcon
        IconLogo={icon}
        width="20px"
        height="20px"
        style={{ color: "transparent" }}
      />
    </Box>
  );
};

export default IconAboveNode;
